// Argus — AdminAlertToast: global Snackbar listener pentru `argus:admin-alert` CustomEvent.
// Folosit la auto-blacklist manifest (server detect ≥3 distinct agents rolled-back same manifest)
// + alte alert-uri admin viitoare.
//
// Bloc auto-blacklist v1.0.5.

import { useEffect, useState } from 'react';
import { Snackbar, Alert, AlertTitle } from '@mui/material';

interface AdminAlertEvent {
  severity?: 'info' | 'warning' | 'error' | 'success';
  category?: string;
  message?: string;
}

export function AdminAlertToast(): JSX.Element {
  const [alert, setAlert] = useState<AdminAlertEvent | null>(null);

  useEffect(() => {
    const handler = (ev: Event) => {
      const ce = ev as CustomEvent<AdminAlertEvent>;
      if (ce.detail?.message) {
        setAlert(ce.detail);
      }
    };
    window.addEventListener('argus:admin-alert', handler);
    return () => window.removeEventListener('argus:admin-alert', handler);
  }, []);

  return (
    <Snackbar
      open={!!alert}
      autoHideDuration={15000}
      onClose={() => setAlert(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={alert?.severity ?? 'warning'}
        onClose={() => setAlert(null)}
        sx={{ minWidth: 400, maxWidth: 600 }}
      >
        <AlertTitle>
          {alert?.category === 'manifest_auto_blacklisted'
            ? 'Manifest auto-blacklisted'
            : 'Admin alert'}
        </AlertTitle>
        {alert?.message ?? ''}
      </Alert>
    </Snackbar>
  );
}
